<template>
  <v-container>
    <v-row style="max-height: calc(100vh - 315px); overflow-y: auto">
      <v-col cols="12">
        <v-timeline
          plain
          :type="simpleTimeline"
          :dense="dense"
        >
          <v-timeline-item
            v-for="(evento, index) in TimeLineData"
            v-bind:key="evento.id"
            :color="evento.color"
            :icon="evento.icon"
            fill-dot
            :style="tabStyle(index)"
          >
            <v-card class="timeline-tab">
              <div class="timeline-tab-title">
                <div class="img"><img :src="evento.badge" /></div>
                <div class="text">{{evento.title}}</div>
              </div>
              <v-card-text
                class="timeline-tab-text"
                :style="timelineTabStyle(evento)"
              >
                {{evento.text}}
                <div class="text-uppercase body-2">
                  <v-btn
                    v-if="evento.ricevutaUrl"
                    icon
                    large
                    color="success"
                    min-width="0"
                    text
                    @click.native="openLink(evento.ricevutaUrl)"
                  >
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="evento.ticketUrl"
                    icon
                    large
                    color="success"
                    min-width="0"
                    text
                    @click.native="openLink(evento.ticketUrl)"
                  >
                    <v-icon>mdi-ticket</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="evento.tesseraUrl"
                    icon
                    large
                    color="success"
                    min-width="0"
                    text
                    @click.native="openLink(evento.tesseraUrl)"
                  >
                    <v-icon>mdi-card-account-details-outline</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="evento.diplomaUrl"
                    icon
                    large
                    color="success"
                    min-width="0"
                    text
                    @click.native="openLink(evento.diplomaUrl)"
                  >
                    <v-icon>mdi-certificate-outline</v-icon>
                  </v-btn>
                  {{ evento.date }}
                </div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "user-time-line",
  props: {
    masterId: null,
  },
  data() {
    return {
      TimeLineData: new Array(),
      responsive: false,
    };
  },
  computed: {
    dense() {
      return this.$vuetify.breakpoint.name === "xs" ? true : false;
    },

    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "";
    },
  },
  methods: {
    openLink(link) {
      this.$documentViewer.documentViewerRsp.docUrl = link;
    },
    tabStyle(index) {
      if (this.$vuetify.breakpoint.name === "xs") return "";
      return index > 0
        ? "margin-top: -80px; height: 200px; position: relative;"
        : "height: 200px;";
    },
    timelineTabStyle(evento) {
      return evento.background
        ? "background-image: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0)), url('" +
            evento.background +
            "'); background-size: contain; background-position: right;"
        : "";
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    loadData() {
      let _ = this;
      let url = "/auth/portal/getUserTimeline/";
      if (_._props.masterId) url += _._props.masterId;
      // Eventi aperti
      this.chiamataAxios("GET", url).then((response) => {
        let data = response.data;
        _.TimeLineData = [];
        for (let e = 0; e < data.length; e++) {
          let evento = {
            id: e,
            inverted: e % 2 == 1 ? _.responsive : true,
            title: data[e].title,
            text: data[e].text,
            ticketUrl: data[e].ticketUrl,
            ricevutaUrl: data[e].ricevutaUrl,
            tesseraUrl: data[e].tesseraUrl,
            diplomaUrl: data[e].diplomaUrl,
            background: data[e].background,
            badge: data[e].badge,
            date: new Date(data[e].date).toLocaleDateString(),
            color: data[e].color,
            icon: data[e].icon,
          };

          _.TimeLineData.push(evento);
        }
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
};
</script>
<style>
.timeline-tab {
  height: 100%;
  background-size: cover;
  display: flex;
  flex-direction: column;
}
.timeline-tab-title {
  padding: 8px;
  border-bottom: 0.5px solid #c0c0c0;
}

.timeline-tab-title .img {
  height: 20px;
  width: 20px;
  float: left;
}
.timeline-tab-title .img img {
  height: 20px;
  width: 20px;
}
.timeline-tab-title .text {
  word-break: break-word;
  text-align: center;
}
.timeline-tab-text {
  flex: 1;
}
</style>
